import React, { useMemo } from 'react';
import { Grid, Typography } from '@mui/material';
import DateFnsAdapter from '@date-io/date-fns';
import { useLocation } from 'react-router-dom';
import { RawData } from '../../listing-packets/components/VirtualizedTable';
import { ReviewData } from '../../solicitor-viewer/components/Footer';
import { formattingDate, formattingEpochDiff } from 'shared/helpers/FormatDate';

const dateFns = new DateFnsAdapter();

const Header: React.FC<HeaderProps> = React.forwardRef(() => {
    const location = useLocation();
    const defaultState = location.state as {
        reviewData: ReviewData[];
        documentData: RawData;
    };

    const documentData = useMemo(
        () =>
            defaultState && defaultState.documentData
                ? defaultState.documentData
                : {
                      _id: '',
                      surName: null,
                      uniqueRef: null,
                      reviewRequired: false,
                      statusMessage: null,
                      slaDate: null,
                      clientId: '',
                      SLADate: new Date(),
                      clientName: '',
                      loanNumber: '',
                      bin: '',
                      packetType: '',
                      operatorId: '',
                      operatorName: '',
                      completedDate: new Date(),
                      escalatedDate: new Date(),
                      uploadedDate: new Date(),
                      recordNo: '',
                      packetStatus: '',
                      actions: null,
                      documents: [],
                  },
        [defaultState]
    );

    const getOperatorName = React.useCallback((operatorName: any) => {
        const lastName =
            typeof operatorName === 'object' && operatorName !== null
                ? operatorName.last
                : '';
        const firstName =
            typeof operatorName === 'object' && operatorName !== null
                ? operatorName.first
                : '';
        const nameOperator = String(firstName).substring(0, 1).toUpperCase();

        return typeof operatorName === 'object' && operatorName !== null
            ? `${lastName}, ${nameOperator}`
            : '-';
    }, []);

    return (
        <Grid
            container
            spacing={2}
            className="header-reviewed-container"
            justifyContent="center"
        >
            <Grid item xs={12} sm={1.7} className="reviewed-detail-item">
                <Typography variant="h4">Checklist</Typography>
                <Typography data-testid="clientName">
                    {documentData.clientName}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={1.7} className="reviewed-detail-item">
                <Typography variant="h4">Cross Check Type</Typography>
                <Typography data-testid="packetType">
                    {documentData.packetType}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={1.7} className="reviewed-detail-item">
                <Typography variant="h4">SLA</Typography>
                <Typography data-testid="SLADate">
                    {formattingEpochDiff(documentData.SLADate)}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={1.7} className="reviewed-detail-item">
                <Typography variant="h4">Reference Number</Typography>
                <Typography data-testid="binnumber">
                    {documentData.bin}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={1.7} className="reviewed-detail-item">
                <Typography variant="h4">Envelope Number</Typography>
                <Typography data-testid="loannumber">
                    {documentData.loanNumber}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={1.7} className="reviewed-detail-item">
                <Typography variant="h4">Uploaded</Typography>
                <Typography data-testid="uploadedDate">
                    {`${formattingDate(
                        documentData.uploadedDate
                    )} (${dateFns.getDiff(
                        new Date(),
                        new Date(documentData.uploadedDate),
                        'days'
                    )} days ago)`}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={1.7} className="reviewed-detail-item">
                <Typography variant="h4">Member ID</Typography>
                <Typography data-testid="operatorid">
                    {getOperatorName(documentData.operatorName)}
                </Typography>
            </Grid>
        </Grid>
    );
});

export default Header;
